import { NavLink, Outlet } from "react-router-dom";
import { Button, Text } from "@radix-ui/themes";
import { signOut, useSession } from "../auth/client";

const links = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/users", label: "Users", end: false },
  { to: "/analytics", label: "Analytics", end: false },
];

export default function AppLayout() {
  const { data: session } = useSession();

  async function onSignOut() {
    await signOut();
    window.location.assign("/");
  }

  return (
    <>
      <nav className="hq-nav">
        <span className="hq-nav__brand">hq</span>
        <div className="hq-nav__links">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              style={({ isActive }) => ({
                padding: "0.25rem 0.6rem",
                borderRadius: "6px",
                textDecoration: "none",
                color: isActive ? "var(--accent-11)" : "var(--gray-11)",
                background: isActive ? "var(--accent-a3)" : "transparent",
                fontWeight: isActive ? 600 : 400,
                fontSize: "0.9rem",
              })}
            >
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className="hq-nav__spacer" />
        <Text size="1" className="hq-muted">
          {session?.user?.email}
        </Text>
        <Button size="1" variant="soft" color="gray" onClick={onSignOut}>
          Sign out
        </Button>
      </nav>
      <main className="hq-main">
        <Outlet />
      </main>
    </>
  );
}
